import '@fortawesome/fontawesome-pro/css/all.css'
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa'
  },  
  theme: {
    themes: {
      light: {
        white: "#FFFFFF",
        button: "#53CFD7",
        blackIcon: "#212121",
        bt_color: "#0067AF",
        bt_color_bg: "#EFF7FF",
        darkBlue: "#192b46",
        lightBlue: "#E3EEF9",
        bt_green: "#00A65A",
        bt_green_bg: "#F0FEF7",
        bt_text: "#24252D",
        bt_pink: "#FF0054",
        bt_pink_bg: "#FDF1F6",
        bt_gray_bg: "#F6F7F7"
      },
      dark: {},
    },
  },
});
